const slider = {
  init () {
    // Image Slider
    if ($('.o-slider').length) {
      $('.o-slider').slick({
        lazyLoad: 'ondemand', // ondemand progressive anticipated
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        prevArrow: '<div class="e-arrow slick-prev"><i class="e-arrow__icon ion-ios-arrow-thin-left"></i></div>',
        nextArrow: '<div class="e-arrow slick-next"><i class="e-arrow__icon ion-ios-arrow-thin-right"></i></div>',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    }

    if ($('.o-slider-alt').length) {
      $('.o-slider-alt').slick({
        lazyLoad: 'ondemand', // ondemand progressive anticipated
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        prevArrow: '<div class="e-arrow slick-prev"><i class="e-arrow__icon ion-ios-arrow-thin-left"></i></div>',
        nextArrow: '<div class="e-arrow slick-next"><i class="e-arrow__icon ion-ios-arrow-thin-right"></i></div>',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    }
    if ($('.o-slider-four').length) {
      $('.o-slider-four').slick({
        lazyLoad: 'ondemand', // ondemand progressive anticipated
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        prevArrow: '<div class="e-arrow slick-prev"><i class="e-arrow__icon ion-ios-arrow-thin-left"></i></div>',
        nextArrow: '<div class="e-arrow slick-next"><i class="e-arrow__icon ion-ios-arrow-thin-right"></i></div>',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    }
  }
};

export default slider;



// WEBPACK FOOTER //
// ./src/components/03-ui/03-slider/03-slider.js